import jwtAuthKioskAxios from "../auth/jwtAuthKiosk";
import { setBackendDomain } from "./management";

export const getDSOKCategory = async (categoryId) => {
  setBackendDomain(jwtAuthKioskAxios);
  const data = await jwtAuthKioskAxios.get(
    `/api/v1/categories/id/${categoryId}`
  );
  return data?.data?.category;
};

/**
 * Update the cross-sell data for a category
 * @param {string} categoryId - The ID of the category to update
 * @param {Object} crossSellData - The cross-sell data to update
 * @returns {Promise<Object>} The updated cross-sell data
 */
export const updateCategoryCrossSell = async (categoryId, crossSellData) => {
  setBackendDomain(jwtAuthKioskAxios);
  const data = await jwtAuthKioskAxios.put(
    `/api/v1/categories/cross-sell/${categoryId}`,
    crossSellData
  );
  return data?.data;
};

export const deleteCategoryBannerImage = async (fileName) => {
  setBackendDomain(jwtAuthKioskAxios);
  const data = await jwtAuthKioskAxios.delete(
    `/api/v1/categories/banner/delete/${fileName}`
  );
  return data?.data;
};

// NOTE: generator API exported below (single definition)

export const getCategoryBannerImages = async () => {
  setBackendDomain(jwtAuthKioskAxios);
  const data = await jwtAuthKioskAxios.get(`/api/v1/categories/banner/list`);
  return {
    images: data?.data?.images,
    baseURL: jwtAuthKioskAxios.defaults.baseURL,
  };
};

export const generateCategoryBannerImage = async (payload) => {
  setBackendDomain(jwtAuthKioskAxios);
  const data = await jwtAuthKioskAxios.post(
    `/api/v1/categories/banner/generate`,
    payload
  );
  return data?.data;
};

export const getCategoryIcons = async () => {
  setBackendDomain(jwtAuthKioskAxios);
  const data = await jwtAuthKioskAxios.get(`/api/v1/categories/icons/get`);
  return data?.data?.icons;
};

export const createDSOKCategory = async (category) => {
  setBackendDomain(jwtAuthKioskAxios);
  try {
    const data = await jwtAuthKioskAxios.post(
      `/dsok/category/create`,
      category
    );
    return data?.data?.category;
  } catch (error) {
    return error?.response?.data?.message;
  }
};
